module.exports = __webpack_public_path__ + "img/vr-chemistry-lab-mobile.06b36dff.jpg";